export class ResultCache {
    constructor() {
        /**
         * Cache of workflow results indexed by resultSchema, primary key, and secondary key
         */
        this.cache = new Map();
        this.bucketSizes = new Map();
    }
    /**
     * Sets the number of results to keep in the cache per bucket.
     * @param resultSchema Schema of map workflow result
     * @param bucketSize The number of results to keep in the cache per bucket
     */
    setBucketSize(resultSchema, bucketSize) {
        this.bucketSizes.set(resultSchema, bucketSize);
    }
    /**
     * Set result of workflow for resultSchema, docId, and tileId
     * @param resultSchema Schema of workflow result
     * @param groupingKey Grouping key to place the result in the cache
     * @param result Result to cache
     */
    setResult(resultSchema, groupingKey, result) {
        if (!groupingKey.primary) {
            return;
        }
        let resultSchemaCache = this.cache.get(resultSchema);
        if (!resultSchemaCache) {
            resultSchemaCache = new Map();
            this.cache.set(resultSchema, resultSchemaCache);
        }
        let primaryKeyCache = resultSchemaCache.get(groupingKey.primary);
        if (!primaryKeyCache) {
            primaryKeyCache = groupingKey.secondary ? new Map() : [];
            resultSchemaCache.set(groupingKey.primary, primaryKeyCache);
        }
        if (groupingKey.secondary) {
            const primaryResultsMap = primaryKeyCache;
            primaryResultsMap.set(groupingKey.secondary, result);
        }
        else {
            const primaryResultsArray = primaryKeyCache;
            if (primaryResultsArray.length == this.getBucketSize(resultSchema)) {
                primaryResultsArray.shift();
            }
            primaryResultsArray.push(result);
        }
    }
    /**
     * Get results for resultSchema and docId grouped by tileId
     * or empty array if the results cannot be found
     * @param resultSchema Schema of workflow result
     * @param groupingKey Grouping key of the result to fetch
     * @returns results grouped by the primary key
     */
    getResults(resultSchema, groupingKey) {
        const resultSchemaCache = this.cache.get(resultSchema);
        if (resultSchemaCache) {
            const primaryResults = resultSchemaCache.get(groupingKey.primary);
            if (primaryResults) {
                if (!groupingKey.secondary) {
                    return primaryResults;
                }
                const results = Array.from(primaryResults.values());
                if (results.length > 0) {
                    return results;
                }
            }
        }
        return [];
    }
    /**
     * Delete results for a given result schema and grouping key
     * @param resultSchema result schema to delete (or undefined to continue to groupingKey-based deletion)
     * @param groupingKey grouping key of the result to delete (or undefined to delete all)
     */
    clear(resultSchema, groupingKey) {
        if (groupingKey) {
            this.cache.forEach((resultsForSchema, schema) => {
                if (!resultSchema || resultSchema === schema) {
                    if (groupingKey.secondary) {
                        const primaryResults = resultsForSchema.get(groupingKey.primary);
                        if (primaryResults) {
                            primaryResults.delete(groupingKey.secondary);
                        }
                    }
                    else {
                        resultsForSchema.delete(groupingKey.primary);
                    }
                }
            });
        }
        else if (resultSchema) {
            this.cache.delete(resultSchema);
        }
        else {
            this.cache.clear();
        }
    }
    getBucketSize(resultSchema) {
        return this.bucketSizes.get(resultSchema) || 10;
    }
}
//# sourceMappingURL=result-cache.js.map